import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconSearch: IconType = () => (
  <Svg viewBox="0 0 31 31">
    <path
      d="M27.9438 30.2361L17.6196 19.9107C13.0269 23.1757 6.69825 22.3771 3.06073 18.0735C-0.576792 13.7699 -0.309699 7.39704 3.67517 3.41287C7.65899 -0.573044 14.0328 -0.841277 18.3375 2.79583C22.6421 6.43294 23.4413 12.7618 20.1758 17.3547L30.5 27.68L27.9456 30.2343L27.9438 30.2361ZM11.3384 3.84999C7.9127 3.84922 4.95723 6.25375 4.26133 9.6078C3.56544 12.9618 5.32038 16.3436 8.46364 17.7055C11.6069 19.0675 15.2746 18.0354 17.2461 15.234C19.2176 12.4327 18.9511 8.63213 16.608 6.13331L17.7009 7.21715L16.4689 5.9888L16.4472 5.96712C15.0955 4.60722 13.2558 3.84483 11.3384 3.84999Z"
      fill="currentColor"
    />
  </Svg>
)
